import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';

import {
    chartGridStroke,
    chartTooltipStyle,
    rtlXAxisProps,
    rtlYAxisProps,
    tickFormatter,
} from '@/features/reports/lib/chartTheme';
import { categoryAxisTick, formatNumber, formatPercent, formatToman } from '@/features/reports/lib/format';

/**
 * Vertical bar chart for the demand breakdowns (weekday, hour of day, month).
 *
 * `highlight` marks the busiest bucket so the eye lands on the answer the
 * report exists to give.
 */
export default function DemandBarChart({
    points = [],
    valueKey = 'revenue',
    highlight = null,
    money = true,
    height = 300,
    color = '#2E7D32',
    highlightColor = '#F59E0B',
    showShare = true,
    xInterval = 0,
}) {
    const format = money ? formatToman : formatNumber;

    const tooltip = ({ active, payload }) => {
        if (!active || !payload?.length) return null;
        const point = payload[0].payload;
        return (
            <div className="report-tooltip">
                <p className="report-tooltip-title">{point.label}</p>
                <p className="report-tooltip-row">
                    <span>{money ? 'درآمد' : 'تعداد'}</span>
                    <strong>{format(point[valueKey])}</strong>
                </p>
                <p className="report-tooltip-row report-tooltip-muted">
                    <span>سفارش</span>
                    <span>{formatNumber(point.orders)}</span>
                </p>
                {showShare && point.revenue_share_pct !== undefined && (
                    <p className="report-tooltip-row report-tooltip-muted">
                        <span>سهم</span>
                        <span>{formatPercent(point.revenue_share_pct)}</span>
                    </p>
                )}
            </div>
        );
    };

    return (
        <div style={{ width: '100%', height }}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart data={points} margin={{ top: 10, right: 10, left: 10, bottom: 5 }}>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke={chartGridStroke} />
                    <XAxis dataKey="label" {...rtlXAxisProps} tickFormatter={categoryAxisTick} interval={xInterval} />
                    <YAxis {...rtlYAxisProps} tickFormatter={tickFormatter} />
                    <Tooltip content={tooltip} contentStyle={chartTooltipStyle} cursor={{ fill: 'rgba(46,125,50,0.06)' }} />
                    <Bar dataKey={valueKey} radius={[6, 6, 0, 0]} name={money ? 'درآمد' : 'تعداد'}>
                        {points.map((point, index) => (
                            <Cell
                                key={point.key ?? point.hour ?? point.weekday ?? index}
                                fill={highlight !== null && index === highlight ? highlightColor : color}
                            />
                        ))}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
}
